<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <corporate-policies-type-card />
        </b-col>
      </b-row>
      <b-row v-if="itemData.id_corporate_policies_type">
        <b-col
          cols="12"
          md="12"
        >
          <hr>
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <component
            :is="currentFormComponent"
            v-if="currentFormComponent"
          />
        </b-col>
      </b-row>
    </b-card>
    <corporate-policies-image-card v-if="itemData.id_corporate_policies_type" />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import CorporatePoliciesTypeCard from '@/views/Admin/Corporate_policies/Elements/FormTypeCard.vue'
import CorporatePoliciesStandartForm from '@/views/Admin/Corporate_policies/Components/StandartForm.vue'
import CorporatePoliciesSubContentForm from '@/views/Admin/Corporate_policies/Components/SubContentForm.vue'
import CorporatePoliciesSubTitleForm from '@/views/Admin/Corporate_policies/Components/SubTitleForm.vue'
import CorporatePoliciesImageCard from '@/views/Admin/Corporate_policies/Elements/Image.vue'

export default {
  name: 'CorporateItemForm',
  components: {
    CorporatePoliciesImageCard,
    CorporatePoliciesTypeCard,
    CorporatePoliciesStandartForm,
    CorporatePoliciesSubContentForm,
    CorporatePoliciesSubTitleForm,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
    formTypes() {
      return this.$store.getters['corporatePoliciesType/dataList']
    },
    currentFormComponent() {
      const match = this.formTypes.find(
        type => type.id === this.itemData.id_corporate_policies_type,
      )
      return match ? match.form_component : null
    },
  },
}
</script>
